var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgTextIcon = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "20px",
    height: "22px",
    viewBox: "0 0 20 22",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "811B0D04-3102-449C-B478-A804FA34708E") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter-1"
  }, /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceGraphic",
    type: "matrix",
    values: "0 0 0 0 0.290222 0 0 0 0 0.290175 0 0 0 0 0.290237 0 0 0 1.000000 0"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Wireframes-2.0",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "6.1-Components---Create-Blueprint-Component",
    transform: "translate(-628.000000, -387.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "003-text",
    transform: "translate(618.000000, 378.000000)",
    filter: "url(#filter-1)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(11.000000, 10.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.248227,0 L0.907801418,0 C0.406436539,0 0,0.406436539 0,0.907801418 L0,4.53900709 C0,5.04037197 0.406436539,5.44680851 0.907801418,5.44680851 C1.4091663,5.44680851 1.81560284,5.04037197 1.81560284,4.53900709 L1.81560284,1.81560284 L8.17021277,1.81560284 L8.17021277,18.1560284 L5.44680851,18.1560284 C4.94544363,18.1560284 4.53900709,18.5624649 4.53900709,19.0638298 C4.53900709,19.5651947 4.94544363,19.9716312 5.44680851,19.9716312 L12.7092199,19.9716312 C13.2105847,19.9716312 13.6170213,19.5651947 13.6170213,19.0638298 C13.6170213,18.5624649 13.2105847,18.1560284 12.7092199,18.1560284 L9.9858156,18.1560284 L9.9858156,1.81560284 L16.3404255,1.81560284 L16.3404255,4.53900709 C16.3404255,5.04037197 16.7468621,5.44680851 17.248227,5.44680851 C17.7495918,5.44680851 18.1560284,5.04037197 18.1560284,4.53900709 L18.1560284,0.907801418 C18.1560284,0.406436539 17.7495918,0 17.248227,0 Z",
    id: "Path",
    stroke: "#979797",
    strokeWidth: 0.3,
    fill: "#000000",
    fillRule: "nonzero"
  })))))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgTextIcon);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/textIcon.c662ce1a13381bf4a5aa6612badcd7e1.svg";